import { render, staticRenderFns } from "./InquiryListPage.vue?vue&type=template&id=39984894&"
import script from "./InquiryListPage.vue?vue&type=script&lang=js&"
export * from "./InquiryListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports